import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/attachment/attachment/list", params, successCallback, failCallback, exceptionCallback);
	},
	listName: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/attachment/attachment/listName", params, successCallback, failCallback, exceptionCallback);
	},
	preview: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/attachment/attachment/download", params, successCallback, failCallback, exceptionCallback);
	},
	download: (params, fileName) => {
		ApiUtils.downloadingAjax(constant.serverUrl + "/attachment/attachment/download", params, fileName);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/attachment/attachment/save", params, successCallback, failCallback, exceptionCallback);
	},
	saveUpload: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/attachment/attachment/saveUpload", params, successCallback, failCallback, exceptionCallback);
	},saveUpload2: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/attachment/attachment/saveUpload2", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/attachment/attachment/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/attachment/attachment/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/attachment/attachment/remove", params, successCallback, failCallback, exceptionCallback);
	},
	
}

export default api;
